import type { CGMSessionEndedEvent } from "@tandemdiabetes/sugarmate-api-react-client"
import {
  ActivityType,
  CGMType,
} from "@tandemdiabetes/sugarmate-api-react-client"
import {
  Label,
  ModalBody,
} from "@tandemdiabetes/sugarmate-react-components"

import { EventModalHeader } from "../EventModalHeader"
import { usePolyglot } from "src/contexts"
import styles from "src/styles/entryModal.module.scss"

interface Props {
  userEvent: CGMSessionEndedEvent;
}

export function CGMSessionEndedEventModal(props: Props) {
  const {
    userEvent,
  } = props

  const polyglot = usePolyglot()

  return (
    <>
      <EventModalHeader
        activityType={ActivityType.CGMSessionEnded}
        userEvent={userEvent}
        closeBtnId="cgm-session-ended-event-close-btn"
      />
      <ModalBody className={styles.modalBody}>
        { userEvent.cgm_session_ended.cgm_type !== CGMType.Undefined && (
          <Label sizePreset="small">
            {polyglot.t(
              "components.activity_summary.message.device_summary",
              {
                device: polyglot.t(`device.${userEvent.cgm_session_ended.cgm_type}`),
              },
            )}
          </Label>
        )}
      </ModalBody>
    </>
  )
}
